import { atomWithStorage } from "jotai/utils";

/**
 * We support theme = 'light' | 'dark'
 * We support font = 'inter' | 'poppins' | 'geist-mono'
 * We support color = 'default' | 'nature' | 'retro'
 */
interface AppearanceState {
  theme: "light" | "dark";
  font: "inter" | "poppins" | "geist-mono";
  color: "default" | "nature" | "retro";
}

// We'll store user preferences in localStorage
// You can adjust the storage key as needed.
export const appearanceAtom = atomWithStorage<AppearanceState>("appearance", {
  theme: "dark",
  font: "poppins",
  color: "default",
});
